import { render, staticRenderFns } from "./TagCollection.vue?vue&type=template&id=d0a5af7e&scoped=true&"
import script from "./TagCollection.vue?vue&type=script&lang=js&"
export * from "./TagCollection.vue?vue&type=script&lang=js&"
import style0 from "./TagCollection.vue?vue&type=style&index=0&id=d0a5af7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a5af7e",
  null
  
)

export default component.exports